// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:17:49

export default {
  "id": "get-a-cool-gun",
  "slug": "get-a-cool-gun",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f9320b27ae2d450fba45cfbe99ddd27a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f9320b27ae2d450fba45cfbe99ddd27a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Get a cool gun!",
      "description": "The dynamic gun runner game gives a shooting experience with the creation and evolution of weapons. Combine parts to get new weapon modules.\nShoot obstacles and enemies to unlock an arsenal of powerful weapons. Test your marksmanship by shooting at targets and enemies.\nImprove your firepower by creating and combining weapon parts. Follow the evolution of weapons, from simple firearms to advanced weaponry. Become a true master of weapon creation!",
      "instructions": "Use your mouse to move around on PC and your finger on your phone.\nTo upgrade weapons, you need to buy and connect parts.",
      "genres": [
        "Casual",
        "Merge"
      ],
      "tags": [
        "3d",
        "arcade",
        "guns",
        "runner",
        "upgrade"
      ]
    },
    "zh-CN": {
      "title": "获得一把酷炫的枪！",
      "description": "动态枪跑游戏提供了一种通过武器创造和进化的射击体验。组合零件以获得新的武器模块。\n射击障碍和敌人以解锁强大的武器库。通过射击目标和敌人来测试你的射击技巧。\n通过创建和组合武器零件来提高你的火力。跟随武器的进化，从简单的枪械到先进的武器。成为真正的武器创造大师！",
      "instructions": "使用鼠标在PC上移动，在手机上使用手指操作。\n要升级武器，你需要购买并连接零件。",
      "genres": [
        "休闲",
        "合并"
      ],
      "tags": [
        "3D",
        "街机",
        "枪械",
        "跑酷",
        "升级"
      ]
    },
    "zh-TW": {
      "title": "獲得一把酷炫的槍！",
      "description": "動態槍手遊戲提供一種以創造和進化武器為主軸的射擊體驗。將零件組合以獲得新的武器模組。\n射擊障礙物和敵人來解鎖強力武器庫。通過射擊目標和敵人來測試你的射術。通過創造和組合武器零件來提升你的火力。跟隨武器進化的腳步，從簡單的火器到先進武器。成為真正的武器創作大師！",
      "instructions": "使用滑鼠在PC上移動，用手指在智慧型手機上操作。\n為了升級武器，你需要購買和連接零件。",
      "genres": [
        "休闲",
        "合併"
      ],
      "tags": [
        "3D",
        "街機",
        "槍械",
        "跑酷",
        "升級"
      ]
    },
    "zh-HK": {
      "title": "搵把潮嘅枪！",
      "description": "動態槍擔遊戲，帶你體驗武器創造與演進的射擊樂趣。合併零件，獲得新武器模組。\n射擊障礙物及敵人，解鎖強大武器庫。透過射擊目標及敵人測試你的射術。透過創造及合併武器零件，提升你的火力。追隨武器的演進，從簡單槍械到先進武器。成為真正的武器創造大師！",
      "instructions": "用鼠標在電腦上移動，用手指在電話上操作。\n要升級武器，你需要購買和連接零件。",
      "genres": [
        "輕鬆",
        "合併"
      ],
      "tags": [
        "3D",
        "街機",
        "槍械",
        "跑酷",
        "升級"
      ]
    },
    "ja": {
      "title": "クールな銃をゲット！",
      "description": "ダイナミックな銃の運搬ゲームは、武器の創造と進化を通じての銃撃体験を提供します。部品を組み合わせて新しい武器モジュールを得ましょう。\n障害物と敵を撃ち、強力な武器のアーミAMENTを解除しましょう。ターゲットと敵に撃ち、狙撃の腕前を試しましょう。\n武器の部品を創造し、組み合わせることで火力を向上させましょう。単純な銃から高度な武器に至る武器の進化を追いかけましょう。武器創造の真のマスターになる吧！",
      "instructions": "パソコンではマウスを使って動き回り、スマートフォンでは指を使って操作してください。\n武器をアップグレードするには、部品を購入して接続する必要があります。",
      "genres": [
        "カジュアル",
        "マージ"
      ],
      "tags": [
        "3D",
        "アーケード",
        "銃",
        "ランナー",
        "アップグレード"
      ]
    },
    "ko": {
      "title": "쉽게 쏘는 총을 얻어라!",
      "description": "동적 총운전자 게임은 무기의 창조와 진화를 통해 쏘아대는 체험을 제공합니다. 부품을 결합하여 새로운 무기 모듈을 얻습니다.\n장애물과 적을 쏘아대어 강력한 무기장을 해금하세요. 목표와 적을 쏘아대어 사격 정확도를 테스트하세요.\n무기 부품을 창조하고 결합하여 병력을 향상시키세요. 간단한 소총에서 고급 무기로까지 무기 진화를 따라가세요. 진정한 무기 창조 마스터가 되세요!",
      "instructions": "컴퓨터에서는 마우스로 이동하고, 스마트폰에서는 손가락으로 이동하세요.\n무기를 업그레이드하려면 부품을 구매하고 연결해야 합니다.",
      "genres": [
        "캐주얼",
        "합성"
      ],
      "tags": [
        "3D",
        "아케이드",
        "총",
        "러너",
        "업그레이드"
      ]
    },
    "fr": {
      "title": "Obtenez une arme géniale !",
      "description": "Le jeu dynamique Gun Runner offre une expérience de tir en créant et en évoluant des armes. Combinez des pièces pour obtenir de nouveaux modules d'armes.\nTirez sur les obstacles et les ennemis pour débloquer une arsène d'armes puissantes. Testez votre habileté au tir en visant des cibles et des ennemis.\nAméliorez votre puissance de feu en créant et en combinant des pièces d'armes. Suivez l'évolution des armes, des simples armes à feu aux armes avancées. Devenez un véritable maître de la création d'armes !",
      "instructions": "Utilisez votre souris pour vous déplacer sur PC et votre doigt sur votre téléphone.\nPour améliorer les armes, vous devez acheter et connecter des pièces.",
      "genres": [
        "Accordéon",
        "Fusion"
      ],
      "tags": [
        "3D",
        "arcade",
        "armes",
        "runner",
        "améliorations"
      ]
    }
  }
};
